import bidi from './bidi';
export default function patchMithril(global) {
  const defaultMithril = global.m;
  const modifiedMithril = function (comp, ...args) {
    const node = defaultMithril.apply(this, arguments);
    if (!node.attrs) node.attrs = {};

    // Allows the use of the bidi attr.
    if (node.attrs.bidi) {
      bidi(node, node.attrs.bidi);
    }
    return node;
  };
  Object.keys(defaultMithril).forEach(key => modifiedMithril[key] = defaultMithril[key]);
  global.m = modifiedMithril;
}
flarum.reg.add('core', 'common/utils/patchMithril', patchMithril);